import { render, staticRenderFns } from "./workflowHistory.vue?vue&type=template&id=53c82b2a&scoped=true&"
import script from "./workflowHistory.vue?vue&type=script&lang=js&"
export * from "./workflowHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c82b2a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53c82b2a')) {
      api.createRecord('53c82b2a', component.options)
    } else {
      api.reload('53c82b2a', component.options)
    }
    module.hot.accept("./workflowHistory.vue?vue&type=template&id=53c82b2a&scoped=true&", function () {
      api.rerender('53c82b2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/workflow/workflowHistory/workflowHistory.vue"
export default component.exports